import { palette } from 'src/styles/colors';
import styled from 'styled-components';

interface FormResultContainerProps {
  result: 'success' | 'failure';
}

export const FormResultContainer = styled.div<FormResultContainerProps>`
  position: relative;
  padding: 1rem;
  border-radius: 16px;

  .gatsby-image-wrapper {
    margin: 0 auto;
    display: block;
    position: relative;
    max-width: 24px;
    margin-bottom: 1rem;
  }

  ${({ result }) =>
    result === 'success' ? `border: 1px solid ${palette.accentBlue};` : ` border: 1px solid ${palette.softRed};`}
`;

